export default {
  label_items_per_page: 'Items per page:',
  label_items_range: '{visible} of {count}',
  label_all: 'All',
};
